module.exports = __webpack_public_path__ + "static/media/next.e25fb6c3.png";